// extracted by mini-css-extract-plugin
export var bodySections = "_5s-8";
export var gray = "_5s-7";
export var green = "_5s-4";
export var iconContainer = "_5s-9";
export var iconWidgetContainer = "_5s-1";
export var phoneIcon = "_5s-2";
export var red = "_5s-5";
export var statusDot = "_5s-3";
export var widgetContainer = "_5s-0";
export var yellow = "_5s-6";